import 'css-chunksrc/client/common/toggleInput/styles.scss';export default {
  "toggleInput": "_toggleInput_1hiq6_1",
  "bar": "_bar_1hiq6_10",
  "toggled": "_toggled_1hiq6_30"
};